import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AgentClientsService } from '../services/agent-clients.service';

/**
 * Global guard that manages agent_clients flag (via LocalStorage and URL params).
 * 
 * This guard runs on every route and:
 * 1. Ensures localStorage.agent_clients exists (initializes as [] if missing)
 * 2. Captures ?agent_client=xxx from URL and persists it to agent_clients array
 * 
 * This is a non-blocking guard - always returns true to allow navigation.
 */
@Injectable({
  providedIn: 'root',
})
export class AgentClientsGuard implements CanActivate {
  constructor(private agentClientsService: AgentClientsService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    console.log('[AgentClientsGuard] Running global check', {
      url: state.url,
      queryParams: route.queryParams,
    });

    // A) Ensure localStorage.agent_clients exists
    this.agentClientsService.ensureLocalStorage();

    // B) Capture URL query param ?agent_client=xxx
    const agentClientParam = route.queryParams['agent_client'];
    
    if (agentClientParam) {
      console.log('[AgentClientsGuard] Detected agent_client param, adding to list:', agentClientParam);
      this.agentClientsService.addAgentClient(agentClientParam);
    }

    // Always allow navigation (non-blocking guard)
    return true;
  }
}
